<service-settings-options
  *ngIf="service"
  [service]="service"
  [services]="services"
  (saveEmitter)="saveService($event)">
</service-settings-options>